// © Microsoft Corporation. All rights reserved.

import { accentFillRest, neutralForegroundRest, neutralLayerCard } from "@microsoft/fast-components-styles-msft";
import { placeholderColor, profileHrColor } from "../../utils/commonJssConstants";

const tagFontSize = "12px";

export const TagInputStyles = {
    tagInputContainer: {
        display: "flex",
        "flex-wrap": "wrap",
        padding: "8px",

        "& .cwt-tag-input": {
            "flex-grow": "1",
            margin: "0 4px",
            padding: "4px",
            "font-size": "14px",
            border: "none",

            "&:focus": {
                outline: "none"
            }
        },

        "& .cwt-tag-item": {
            display: "flex",
            "align-items": "center",
            margin: "2px",
            padding: "1px 0 2px",
            "font-size": tagFontSize,
            background: neutralLayerCard,
            color: accentFillRest,
            border: "1px solid "+profileHrColor,
            "border-radius": "4px",

            "&:before": {
                content: "''",
                width: "8px"
            },

            "& .cwt-icon": {
                cursor: "pointer",
                margin: "2px 0 0",
                padding: "3px 6px",
                color: placeholderColor,
                opacity: "1",

                "&:hover": {
                    color: neutralForegroundRest
                }
            }
        }
    }
};